import styled from 'styled-components';

export const HeaderRenderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BlockVideoEventInputWrapper = styled.div`
  display: flex;
  width: 500px;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
`;
